import { createReducer } from "redux-act";

import {
  REQSendPushNoti,
  RESSendPushNoti,
  FailSendPushNoti,
  CleanUpPushNoti
} from "./actions";

const initialState = {
  REQStrSendPushNoti: false,
  SendResults: [],
  SendSummary: null,
  errorMessage: false
};

const pushNotiComposeReducer = createReducer(
  {
    [REQSendPushNoti]: state => {
      return {
        ...state,
        REQStrSendPushNoti: true,
        SendResults: [],
        SendSummary: null,
        errorMessage: false
      };
    },

    [RESSendPushNoti]: (state, payload) => {
      return {
        ...state,
        REQStrSendPushNoti: false,
        SendResults: payload.results,
        SendSummary: payload.summary,
        errorMessage: false
      };
    },

    [FailSendPushNoti]: (state, payload) => {
      return {
        ...state,
        REQStrSendPushNoti: false,
        errorMessage: (payload && payload.message) || "ส่งไม่สำเร็จ"
      };
    },

    [CleanUpPushNoti]: () => {
      return initialState;
    }
  },

  initialState
);

export default pushNotiComposeReducer;
